export { default } from './CicPendingCard';
